<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Periodos de Campañas</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                        aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Inicio</label>
                                    <p-calendar appendTo="body" formControlName="FechaInicio" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Fin</label>
                                    <p-calendar appendTo="body" formControlName="FechaFin" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inputGrupo">Campaña</label>
                                    <ng-select
                                        appendTo="body"
                                        [items]="campanias"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdCampania"
                                               loadingText="Cargando..."
                                               [loading]="(!campanias || campanias.length === 0)"
                                               placeholder="-- Seleccione una Campaña --"
                                               [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                               (change)="onSelectCampania($event)"
                                               notFoundText="Campaña no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="DescripcionPeriodo">Periodo</label>
                                    <input formControlName="DescripcionPeriodo" name="DescripcionPeriodo" maxlength="255"
                                            class="form-control" id="DescripcionPeriodo" type="text" value="">
                                </div>
                                
                            </div>

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="Parcela">Parcela</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Parcela"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="Confeccion">Confección</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Confeccion"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="EmpresaDeshidratacion">Empresa Deshidratación</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="EmpresaDeshidratacion"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="Invernadero">Invernadero</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Invernadero"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                            [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                                <i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                            [disabled]="formIsUntouched()"
                                            title="Limpia los filtros" (click)="resetForm($event)">
                                                <i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
